import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            flexDir: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            pb: remCalc(16),
            textAlign: 'center',
        },
        iconContainer: {
            pb: remCalc(18),
            pt: remCalc(66),
            width: '100%',
        },
        textContainer: {
            flexDir: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(24),
        },
        alertIcon: {
            color: 'text.danger',
            width: remCalc(32),
            height: remCalc(32),
        },
        text: {
            color: 'text.default',
            fontWeight: 'normal',
        },
    },
    parts: ['container', 'iconContainer', 'textContainer', 'text', 'alertIcon'],
}
